import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { UtilService } from 'src/app/service/util.service';
import { ToastService } from 'src/app/service/toast.service';
import { Constants } from 'src/app/constants/constants';

@Component({
  selector: 'transaction-detail',
  templateUrl: './transaction-detail.component.html',
  styleUrls: ['./transaction-detail.component.scss']
})
export class TransactionDetailComponent implements OnInit {

  @Input() invoice;

  transactions: any;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
  }

  getTransactions() {
    this.utilService.showSpinner();
    this.apiService.getTransactions(this.invoice.invoiceId).then((data) => {
      this.utilService.hideSpinner();
      this.transactions = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getTransactions();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

}
